import(/* webpackMode: "eager" */ "/codebuild/output/src1917090841/src/company/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1917090841/src/company/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/codebuild/output/src1917090841/src/company/src/app/(service)/_components/Navbar.tsx");
